export default __webpack_public_path__ + "static/media/blur.88e2d7ef.png";